import { Image, Info } from 'components';

export default function ThresholdInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person vaulting over a high jump bar" path="threshold.png" title="Threshold" />
        <h5>Threshold</h5>
        <p>
            The <span className="fst-italic">Threshold</span> is the number you are trying to beat with your results. This calculator will use this number to tell you if your <span className="fst-italic">Results</span> are better than the <span className="fst-italic">Threshold</span>.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If you want to be certain that more than 3 out of 4 doctors will recommend a toothpaste, then the <span className="fst-italic">Threshold</span> should be set to 75%.
            <br/>
            <br/>
            If you don&apos;t have a specific number you need to beat or you are testing between two variations, leave this blank.
        </p>
    </Info>;

}